import {
  Dropdown,
  Form,
  Button,
  Table,
  Badge,
  InputGroup,
} from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "./../../assets/scss/scoped/invoicelist.scoped.scss";
import "./../../assets/scss/reports/cashbook.scss";

import useDebounce, {
  useEffectOnce,
  useIsAdmin,
  useIsCashier,
  useLocalStorage,
  useQueryParams,
} from "../../utils/hooks";
import Select from "react-select";
import CachedIcon from "mdi-react/CachedIcon";
import NewCustomerModal from "../NewCustomerModal";
import { queryActions } from "../../utils/reactQueryActions";
import { useMutation, useQuery } from "react-query";
import queryString from "query-string";
import { useStoreActions, useStoreState } from "easy-peasy";
import { services } from "../../config";

import {
  customerFullName,
  customerTypeOptions,
  didYouKnowOptions,
  formatNumberSystem,
  employeeFullName,
  paginationOptions,
  searchParamsToObject,
  fetchActionsUtil,
} from "../../utils/helpers";
import { useAuth } from "../../hooks/useAuth";
import ReactPaginate from "react-paginate";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import SetSalesRepModal from "./SetSalesRepModal";
import { format } from "date-fns";
import currency from "currency.js";
import {
  DeleteIcon,
  EditIcon,
  FileListIcon,
  ViewIcon,
  QuotationIcon,
  UserIcon,
  ExportIcon,
  ExcelIcon,
  EmailIconWhite,
  CoinIcon,
  ReportIcon,
  ChartPieSliceIcon,
  RecieptIcon,
  CheckCircleIcon,
  FlagIcon,
  FilterTwoIcon,
  FilterCollapseIcon,
} from "../Icons";
import EditCustomerModal from "../EditCustomerModal";
import { toast } from "react-toastify";
import ModalLoader from "../utils/ModalLoader";
import CustomerProducts from "../CustomerProducts";
import { isEmpty, uniqBy } from "lodash";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import { CSVLink } from "react-csv";
import NoTableItem from "../utils/NoTableItem";
import ConfirmDialog from "../ConfirmDialogue";
import { IsPrivileged } from "../DisplayChildElement";
import { CustomerOpeningBalance } from "../CustomerDetails/CustomerOpeningBalance";
import CustomersPasswordModal from "../modals/CustomersPasswordModal";
import CustomerReportModal from "./CustomerReportModal";
import { HoverDropDown } from "../Component";
import CheckDecagram from "mdi-react/CheckDecagramIcon";
import moment from "moment";
import NewCustomerRequisition from "../Requisition/NewCustomerRequisition";

const registeredFromOptions = [
  {
    label: "All",
    value: "All",
  },
  {
    label: "Online Store",
    value: "Online Store",
  },
];

export function CustomerActivationTable({ Dept = "Local" }) {
  const [searchParams] = useSearchParams();
  const { backendUrl, token, user: authUser } = useAuth();
  const [showCreateNewCustomerModal, setShowCreateNewCustomerModal] = useState(
    false
  );
  const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);

  const [showProductModal, setShowProductModal] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showSalesRepManager, setShowSalesRepManager] = useState(null);
  const [
    selectedCustomerOpeningBalance,
    setSelectedCustomerOpeningBalance,
  ] = useState(null);

  const [showFilter, setShowFilter] = useLocalStorage("showFilter", true);
  const navigate = useNavigate();
  const [passwordModal, setPasswordModal] = useState({
    modal: false,
    name: "",
    userId: "",
  });

  // fetch excel hook
  const [excelData, setExcelData] = useState([]);
  const CSVLinkRef = useRef(null);
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );
  const isAdmin = useIsAdmin();
  const isCashier = useIsCashier();
  const [showNewRequisitionModal, setShowNewRequisitionModal] = useState(false);
  const [newRequisition, setNewRequisition] = useState({});

  const initialFilterParams = {
    q: "",
    page: 1,
    limit: 40,
    Dept,
    withReferal: true,
    subscription: true,

    ...(authUser?.invexVersion === "InvexInvoicing" && {
      Staff_ID: authUser?.Staff_ID,
    }),
  };

  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const [customerReport, setCustomerReport] = useState("");
  const debouncedFilterParams = useDebounce(filterParams, 500);

  const generalSettings = useStoreState((state) => state.generalSettings);

  useEffect(() => {
    setQueryParams({ ...queryParams, ...debouncedFilterParams });
  }, [debouncedFilterParams]);

  // action form url query on render once
  useEffectOnce(() => {
    const queryParams = searchParamsToObject(searchParams.entries());
    if (queryParams?.action === "create") {
      setShowCreateNewCustomerModal(true);
      // delete queryParams.action;
      setQueryParams({ ...initialFilterParams });
    }
  });

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
    });
  };

  const getCustomer = async (debouncedqueryParams) => {
    let response = await fetch(
      `${backendUrl}/api/customers/customer-subscriptions?${queryString.stringify(
        debouncedqueryParams
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
      }
    );
    if (!response.ok) {
      response = await response.json();

      throw new Error(response.message);
    }
    const { data } = await response.json();

    data.customerTypes = uniqBy(
      [
        ...customerTypeOptions,
        ...data.customerTypes
          .filter((el) => el.TransType)
          .map((el) => ({
            value: el.TransType,
            label: el.TransType,
          })),
      ],
      "value"
    );

    data.groups = uniqBy(
      [
        ...data.groups
          .filter((el) => el.Group)
          .map((el) => ({
            value: el.Group,
            label: el.Group,
          })),
      ],
      "value"
    );

    return data;
  };

  const {
    data = { customers: [], customerTypes: [] },
    refetch,
    isFetching,
    isSuccess,
  } = useQuery(
    [queryActions.CUSTOMERS, queryParams],
    () => getCustomer(queryParams),
    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const deleteCustomer = async (payload) => {
    let response = await fetch(`${backendUrl}/api/customers/delete`, {
      method: "POST",
      // credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteCustomerMutation = useMutation(
    (payload) => deleteCustomer(payload),
    {
      onSuccess: ({ message, data }) => {
        refetch();
        toast.success(message);
      },
      onError: () => {
        toast.error(`Unable to perform action`);
      },
    }
  );

  const manageSalesRep = (el) => {
    setSelectedCustomer(el);
    setShowSalesRepManager(true);
  };

  const reportCustomer = (el) => {
    setCustomerReport(el);
  };

  const editCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowEditCustomerModal(true);
  };

  const handlefedeleteCustomer = async (customer) => {
    if (customer.Cust_ID === "000101") {
      toast.info("Not Allowed: You cannot delete this customer");
      return;
    }

    if (
      await ConfirmDialog({
        type: "danger",
        title: "Delete Customer",
        description: `Are you sure, you want to delete ${customerFullName(
          customer
        )} `,
      })
    ) {
      deleteCustomerMutation.mutate(customer);
    }
  };

  const createInvoice = async (customer) => {
    console.log(customer);
  };

  const onDownloadExcelData = async () => {
    const { limit, page, ...rest } = queryParams;
    let exData = await fetchExcelData(
      `${backendUrl}/api/customers?${queryString.stringify(rest)}`,
      "GET"
    );

    exData = exData?.data?.customers?.map((d, i) => [
      data?.startIndex + i + 1,
      d?.Cust_ID,
      customerFullName(d),
      d?.TransType,
      d?.PhoneNo1,
      d?.ContactAddress || "...",
      d?.CompanyAddress || "...",
      d?.Email || "...",
      d?.How_Did_Know,
      d?.DateLog,
      d.DOB ? format(new Date(d.DOB), "dd MMM") : "...",
      currency(d?.Customer_CreditLimit?.CreditLimit, {
        symbol: "",
      }).format(),
      d?.Branch,
    ]);
    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy k:mm:ss z"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy k:mm:ss z")}`
        : "";
    exData = [
      ["Customers Report"],
      [date],
      [""],
      [
        "S/N",
        "Cust ID",
        "Business Name",
        "Transaction Type",
        "Phone",
        "Contact Address",
        "Company Address",
        "Email",
        "Acquisition",
        "DateLog",
        "DOB",
        "Credit Limit",
        "Branch",
      ],
      ...exData,
      [""],
    ];
    console.log(exData);
    setExcelData(exData);
  };
  // isprivileged

  const verifyCustomerMutation = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/customers/verify-user/${payload.Cust_ID}`,
        "POST",
        token,
        {
          ...payload,
        }
      ),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ error, message }) => {
        console.log(error);
        toast.error(message);
      },
    }
  );

  const verifyCustomer = async (customer) => {
    if (!isAdmin) {
      toast.error("You are not authorized to perform this action");
      return;
    }
    if (
      await ConfirmDialog({
        title: `${customer.isVerified ? "Unverify" : "Verify"} Customer`,
        description: `Are you sure you want to ${
          customer.isVerified ? "unverify" : "verify"
        } ${customerFullName(customer)}?`,
      })
    ) {
      verifyCustomerMutation.mutate({
        Cust_ID: customer.Cust_ID,
        isVerified: !customer.isVerified,
      });
    }
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      //   ...queryParams,
      ...initialFilterParams,
    });
  };
  const delistCustomerMutation = useMutation(
    async (payload) => {
      // make the requisition here
      const employeeName = payload.LastName;
      const employeeId = payload.Cust_ID;
      const requisition = {
        title: "Customer De-listing",
        description: `Customer: ${customerFullName(
          payload
        )} has been de-listed`,
        amount: 0,
        type: "others",
        requestto: authUser.Staff_ID,
        status: "Pending",
        regdate: moment(new Date()).format("YYYY-MM-DD"),
        requestby: authUser.Staff_ID,
        comment: "",
        filledFormData: "",
        loanDetails: JSON.stringify({ employeeName, employeeId }),
      };
      const formData = new FormData();
      for (const [key, value] of Object.entries(requisition)) {
        formData.append(key, value);
      }
      if (!Boolean(Number(payload?.delist))) {
        const res = await fetch(`${backendUrl}/api/requisition/create`, {
          method: "POST",
          headers: {
            Authorization: `Token ${token}`,
          },
          body: formData,
        });

        if (!res.ok) {
          const data = await res.json();
          throw Error(data);
        }
      }

      return fetchActionsUtil(
        `${backendUrl}/api/customers/toggle-delist/${payload.Cust_ID}`,
        "POST",
        token
      );
    },
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ error, message }) => {
        console.log(error);
        toast.error(message);
      },
    }
  );
  const enlistCustomerMutation = useMutation(
    async (payload) => {
      return fetchActionsUtil(
        `${backendUrl}/api/customers/toggle-delist/${payload.Cust_ID}`,
        "POST",
        token
      );
    },
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ error, message }) => {
        console.log(error);
        toast.error(message);
      },
    }
  );

  const handleCustomerDelisting = async (customer) => {
    let result = false;

    if (!isAdmin && Boolean(Number(customer?.delist))) {
      toast.error("Customer need to be approved before enlisting");
      return;
    }
    if (!isAdmin && !Boolean(Number(customer?.delist))) {
      toast.error("Only an admin can delist a customer");
      return;
    }

    if (Boolean(Number(customer?.delist))) {
      result = await ConfirmDialog({
        type: "danger",
        title: "Enlist Customer",
        description: `<div>
           <b>Note: </b> This action will required the approval of an admin for the customer to be enlisted 
           </div>`,
      });

      if (result) {
        const payload = customer;
        const employeeName = payload.LastName;
        const employeeId = payload.Cust_ID;
        setNewRequisition({
          title: "Customer En-listing",
          description: "This action enlist a customer from the system",
          type: "Enlist",
          cost: 0,
          vendor: `${payload.LastName} / ${payload.Cust_ID}`,
          loanDetails: JSON.stringify({ employeeName, employeeId }),
          Cust_ID: payload.Cust_ID,
        });
        setShowNewRequisitionModal(true);

        // enlistCustomerMutation.mutate(customer);

        return;
      }
    }
    if (!Boolean(Number(customer?.delist))) {
      result = await ConfirmDialog({
        type: "danger",
        title: "Delist Customer",
        description: `<div>
           <b>Note: </b> This action will required the approval of an admin for the customer to be de-listed 
           </div>`,
      });
    }

    if (result) {
      const payload = customer;
      const employeeName = payload.LastName;
      const employeeId = payload.Cust_ID;
      setNewRequisition({
        title: "Customer De-listing",
        description: "This action delist a customer from the system",
        type: "Delist",
        cost: 0,
        vendor: `${payload.LastName} / ${payload.Cust_ID}`,
        loanDetails: JSON.stringify({ employeeName, employeeId }),
        Cust_ID: payload.Cust_ID,
      });

      setShowNewRequisitionModal(true);

      // delistCustomerMutation.mutate(customer);
    }
  };
  return (
    <IsPrivileged
      roleName={[
        "Online Store Customer List",
        "Customer List",
        "New Customer",
        "Customer Subscription List",
      ]}
    >
      <section className="cashbook-wrapped">
        <main className="cash-book">
          <div className="content">
            <div className="content-main">
              <div className={`filter-area ${showFilter ? "open" : "close"}`}>
                <div className="filter-header">
                  <h2>
                    <FilterTwoIcon /> Filters
                  </h2>

                  <Button
                    variant="white"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <FilterCollapseIcon />
                  </Button>
                </div>

                <div className="filter-body">
                  <Form className=" p-2">
                    <div className=" mb-3">
                      <Form.Group>
                        <Form.Label>Search</Form.Label>
                        <InputGroup>
                          <Form.Control
                            id="queryParams-q"
                            className=""
                            name="LastName"
                            value={filterParams.LastName}
                            onChange={(e) => handleSearchQueryChange(e)}
                            placeholder="Search..."
                          />
                          <InputGroup.Text>
                            <MagnifyIcon />
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                    </div>
                    <Form.Group className=" mb-3">
                      <Form.Label>Customer Type</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder="Customer Type"
                        name="TransType"
                        isSearchable={true}
                        onChange={(selected) => {
                          setFilterParams({
                            ...filterParams,
                            TransType: selected?.value,
                          });
                        }}
                        value={data.customerTypes.find(
                          (el) => el.value === filterParams.TransType
                        )}
                        options={data.customerTypes || []}
                        isClearable
                      />
                    </Form.Group>
                    <Form.Group className=" mb-3">
                      <Form.Label>Subscription</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        menuPosition="fixed"
                        menuPlacement="auto"
                        placeholder="Expiration period"
                        name="expirationPeriod"
                        isSearchable={true}
                        onChange={(selected) => {
                          setFilterParams({
                            ...filterParams,
                            expirationPeriod: selected?.value,
                          });
                        }}
                        value={[
                          {
                            label: "Active",
                            value: "active",
                          },
                          {
                            label: "Expires soon",
                            value: "soon",
                          },
                          {
                            label: "3 month to expiration",
                            value: "three",
                          },
                          {
                            label: "6 months to expiration",
                            value: "six",
                          },

                          {
                            label: "Expired",
                            value: "expired",
                          },
                        ].find(
                          (el) => el.value === filterParams?.expirationPeriod
                        )}
                        options={[
                          {
                            label: "Active",
                            value: "active",
                          },
                          {
                            label: "Expires soon",
                            value: "soon",
                          },
                          {
                            label: "3 month to expiration",
                            value: "three",
                          },
                          {
                            label: "6 months to expiration",
                            value: "six",
                          },

                          {
                            label: "Expired",
                            value: "expired",
                          },
                        ]}
                        isClearable
                      />
                    </Form.Group>
                    <div className="buttons rounded">
                      <Button onClick={() => reset()} variant="white">
                        Reset
                      </Button>
                      {/* <Button onClick={() => search()} variant="primary">
                                            Search
                                          </Button> */}
                    </div>
                  </Form>
                </div>
              </div>

              <div className="content-body">
                <header className="p-4 ">
                  <h1>
                    {!showFilter && (
                      <button
                        onClick={() => setShowFilter(!showFilter)}
                        className="btn filter"
                      >
                        <FilterTwoIcon />
                      </button>
                    )}
                    Customer Subscriptions
                    <button
                      title="Refresh"
                      onClick={() => refetch()}
                      className="btn text-primary"
                    >
                      <CachedIcon />
                    </button>
                  </h1>
                  <div className="search-area d-flex flex-wrap- justify-content-end gap-5 ">
                    <div
                      className="d-flex flex-wrap gap-3 justify-content-end"
                      style={{ fontSize: "0.875rem" }}
                    >
                      {/* <Form.Group>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="Customer Groups"
                          name="Group"
                          isSearchable={true}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              Group: selected?.value,
                            });
                          }}
                          value={data.groups?.find(
                            (el) => el.value === filterParams.Group
                          )}
                          options={data.groups || []}
                          isClearable
                        />
                      </Form.Group>
                      {Dept !== "Online Store" && (
                        <Form.Group>
                          <Select
                            classNamePrefix="form-select"
                            menuPosition="fixed"
                            menuPlacement="auto"
                            placeholder="Registered From"
                            name="Dept"
                            isSearchable={true}
                            onChange={(selected) => {
                              setFilterParams({
                                ...filterParams,
                                Dept: selected?.value
                                  ? selected?.value
                                  : "Local",
                              });
                            }}
                            value={registeredFromOptions.find(
                              (el) => el.value === filterParams.Dept
                            )}
                            options={registeredFromOptions || []}
                            isClearable
                          />
                        </Form.Group>
                      )}
                      <Form.Group>
                        <Select
                          classNamePrefix="form-select"
                          menuPosition="fixed"
                          menuPlacement="auto"
                          placeholder="How did you know about us"
                          name="How_Did_Know"
                          isSearchable={true}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              How_Did_Know: selected?.value,
                            });
                          }}
                          value={didYouKnowOptions.find(
                            (el) => el.value === filterParams.How_Did_Know
                          )}
                          options={didYouKnowOptions || []}
                          isClearable
                        />
                      </Form.Group> */}
                      <CSVLink
                        className="btn print d-none"
                        filename={`Customers Report(${format(
                          new Date(),
                          "dd-MMM-yyyy hh:mm:ss a"
                        )}).csv`}
                        data={excelData}
                        ref={CSVLinkRef}
                      />
                      <Dropdown>
                        <Dropdown.Toggle
                          variant=""
                          className="btn print"
                          disabled={isfetchingExcel}
                          bsPrefix=""
                        >
                          Export
                          <ExportIcon color="#008000" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          popperConfig={{
                            strategy: "fixed",
                          }}
                          renderOnMount
                          className="text-center"
                        >
                          <Dropdown.Item
                            as="div"
                            onClick={onDownloadExcelData}
                            className="p-cursor"
                          >
                            Excel <ExcelIcon color="#008000" />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>{" "}
                      {/*  <Link
                className="  gap-1 btn  d-flex align-items-center bg-light-blue  border "
                to={"/send-customers-email"}
              >
                Mail <EmailIconWhite />
              </Link> */}
                      <Button
                        variant="primary"
                        onClick={() => {
                          if (
                            data.customers?.length >= 10 &&
                            authUser?.planType?.toLowerCase() === "free"
                          ) {
                            toast.warn("Upgrade plan to create more customers");

                            return;
                          }

                          setShowCreateNewCustomerModal(true);
                        }}
                      >
                        + Create New
                      </Button>
                    </div>
                  </div>
                </header>

                <div className="px-md-4" />

                <div className="content px-4 pb-4">
                  {customerReport && (
                    <CustomerReportModal
                      customer={customerReport}
                      onClose={setCustomerReport}
                    />
                  )}
                  <Table
                    borderless
                    striped={!filterParams?.TransType === "delist"}
                    responsive
                    className="product-table"
                    hover={filterParams?.TransType === "delist"}
                  >
                    <thead className="sticky border-bottom">
                      <tr>
                        <th />
                        {/* <th>{" "}</th> */}
                        <th>Cust ID</th>
                        <th>Business Name</th>
                        <th>Date of Sub.</th>
                        <th>Expiration Date</th>
                        <th>Status</th>
                        <th>Delist Date</th>
                        <th>Enlist Date</th>
                      </tr>
                    </thead>

                    <tbody
                      className={`  ${
                        filterParams?.TransType === "delist"
                          ? "light-red  table-hover"
                          : "blue-hover"
                      }`}
                    >
                      {data.customers &&
                        data.customers.map((el, index) => (
                          <tr key={index}>
                            <td>
                              <Dropdown alignRight drop="end">
                                <Dropdown.Toggle
                                  variant=""
                                  className="bg-white border-0"
                                  bsPrefix="print more"
                                >
                                  <DotsVerticalIcon />
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                  popperConfig={{
                                    strategy: "fixed",
                                  }}
                                  renderOnMount
                                  className="dropdown-with-icons"
                                >
                                  <Dropdown.Item as="button">
                                    <Link
                                      to={`/sales-and-invoicing/customer-overview?customerId=${
                                        el?.Cust_ID
                                      }`}
                                    >
                                      <UserIcon />
                                      Profile
                                    </Link>
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => editCustomer(el)}
                                    as="button"
                                  >
                                    <EditIcon />
                                    Edit Customer
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    as="div"
                                    onClick={() =>
                                      setPasswordModal({
                                        userId: el?.Cust_ID,
                                        modal: true,
                                        name: customerFullName(el),
                                        Branch: [],
                                      })
                                    }
                                    className="p-cursor"
                                  >
                                    <EditIcon /> {`Change Password`}
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setSelectedCustomer(el);
                                      setShowProductModal(true);
                                    }}
                                    as="button"
                                  >
                                    <UserIcon />
                                    Add Customer Product
                                  </Dropdown.Item>
                                  <Link
                                    to={`/sales-and-invoicing/create-proforma-invoice`}
                                    state={{ customer: el }}
                                  >
                                    <Dropdown.Item as="button">
                                      <QuotationIcon />
                                      Create{" "}
                                      {`${generalSettings.pendingInvoiceType}`}
                                    </Dropdown.Item>
                                  </Link>
                                  <Link
                                    to={`/sales-and-invoicing/create-invoice`}
                                    state={{ customer: el }}
                                  >
                                    <Dropdown.Item as="button">
                                      <RecieptIcon />
                                      Create Invoice
                                    </Dropdown.Item>
                                  </Link>
                                  <Link>
                                    <Dropdown.Item
                                      onClick={() => reportCustomer(el)}
                                      as="button"
                                    >
                                      <QuotationIcon />
                                      Customer Feedback
                                    </Dropdown.Item>
                                  </Link>

                                  <HoverDropDown
                                    alignRight
                                    drop="end"
                                    className="w-100"
                                  >
                                    <Dropdown.Toggle
                                      variant=""
                                      className="w-100 dropdown-item justify-content-between"
                                    >
                                      <span className="d-flex gap-2">
                                        <ChartPieSliceIcon /> Reports
                                      </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="dropdown-with-icons">
                                      <Dropdown.Item
                                        onClick={() => manageSalesRep(el)}
                                        as="button"
                                      >
                                        <EditIcon />
                                        Sales Rep
                                      </Dropdown.Item>

                                      <Link
                                        to={`/reports/sales-analysis?customerId=${
                                          el.Cust_ID
                                        }&startDate=&endDate=`}
                                        state={{ customer: el }}
                                      >
                                        <Dropdown.Item as="button">
                                          <ViewIcon />
                                          View Sales History
                                        </Dropdown.Item>
                                      </Link>

                                      <Link
                                        to={`/reports/customer-ledger?customerId=${
                                          el.Cust_ID
                                        }&customerName=${customerFullName(el)}`}
                                      >
                                        <Dropdown.Item as="button">
                                          <ViewIcon />
                                          View Customer Ledger
                                        </Dropdown.Item>
                                      </Link>
                                    </Dropdown.Menu>
                                  </HoverDropDown>

                                  <Dropdown.Item as="button">
                                    <Link
                                      to={`/reports/customer-target?customerId=${
                                        el?.Cust_ID
                                      }`}
                                    >
                                      <ViewIcon /> Customer Performance
                                    </Link>
                                  </Dropdown.Item>

                                  {isAdmin || isCashier ? (
                                    <>
                                      <Dropdown.Item
                                        onClick={() => {
                                          verifyCustomer(el);
                                        }}
                                        as="button"
                                      >
                                        <CheckCircleIcon />
                                        {el.isVerified
                                          ? "Unverify"
                                          : "Verify"}{" "}
                                        Customer
                                      </Dropdown.Item>

                                      <Dropdown.Item
                                        onClick={() => {
                                          setSelectedCustomerOpeningBalance(el);
                                        }}
                                        as="button"
                                      >
                                        <CoinIcon />
                                        Post Opening Balance
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          handleCustomerDelisting(el);
                                        }}
                                        as="button"
                                      >
                                        <Form.Switch
                                          checked={Boolean(Number(el?.delist))}
                                        />
                                        {Boolean(Number(el?.delist))
                                          ? "Relist"
                                          : "Delist"}{" "}
                                        Customer
                                      </Dropdown.Item>
                                      {/* Number(el?.activateCustomer) */}

                                      {generalSettings.enableCustomerSubscriptionActivation && (
                                        <>
                                          {Boolean(
                                            Number(el?.initialActivateCustomer)
                                          ) ? (
                                            Boolean(
                                              Number(el?.activateCustomer)
                                            ) ? (
                                              <Dropdown.Item
                                                className=" text-success"
                                                as={"div"}
                                              >
                                                <RecieptIcon /> Subscription
                                                Active
                                              </Dropdown.Item>
                                            ) : (
                                              // <button onClick={()=> naviga}>

                                              // </button>

                                              <Dropdown.Item
                                                as={"button"}
                                                onClick={() => {
                                                  navigate(
                                                    `/inventory-for-sales/manage-subscription-transaction`,
                                                    {
                                                      state: {
                                                        TransactionID:
                                                          el.renewalSubscriptionId,
                                                      },
                                                    }
                                                  );
                                                }}
                                              >
                                                <RecieptIcon />
                                                Subscribe Customer
                                              </Dropdown.Item>
                                            )
                                          ) : (
                                            <Dropdown.Item>
                                              <Link
                                                to={`/sales-and-invoicing/activate-customer-invoice?customerId=${
                                                  el?.Cust_ID
                                                }`}
                                              >
                                                <RecieptIcon />
                                                Subscribe Customer
                                              </Link>
                                            </Dropdown.Item>
                                          )}
                                        </>
                                      )}
                                      <Dropdown.Divider />

                                      <Dropdown.Item
                                        onClick={() =>
                                          handlefedeleteCustomer(el)
                                        }
                                        as="button"
                                        className="text-danger"
                                      >
                                        <DeleteIcon />
                                        Delete
                                      </Dropdown.Item>
                                    </>
                                  ) : null}
                                </Dropdown.Menu>{" "}
                              </Dropdown>
                            </td>
                            {/* <td className="text-nowrap">
                      {formatNumberSystem(el?.numberPrefix, el?.currentNumber)}
                    </td> */}
                            <td>{el.Cust_ID}</td>
                            <td>
                              {customerFullName(el)}{" "}
                              {el.isVerified ? (
                                <CheckDecagram
                                  size="1em"
                                  className="text-success"
                                />
                              ) : null}
                            </td>
                            {/* <td>{el.TransType}</td>
                    <td className="text-nowrap">{el.PhoneNo1}</td>
                    <td>{el?.ContactAddress || "..."}</td>
                    <td>{el?.CompanyAddress || "..."}</td>
                    <td>{el.Email || "..."}</td>
                    <td>{el.country || "..."}</td> */}
                            {/* <td>{el.state || "..."}</td> */}
                            {/* <td>{el.LGA || "..."}</td> <td>{el.Group || "..."}</td>{" "}
                    <td className="text-nowrap">
                      {employeeFullName(el?.Customer_referal_EmployeeID)}
                    </td>
                    <td>{el.How_Did_Know}</td>
                    <td>{el.DateLog}</td> */}
                            {/* <td className="text-nowrap">
                      {el.DOB ? format(new Date(el.DOB), "dd MMM") : "..."}
                    </td>
                    <td>
                      {currency(el?.Customer_CreditLimit?.CreditLimit, {
                        symbol: "",
                      }).format()}
                    </td> */}
                            <td>
                              {el.dateOfSubscription
                                ? format(
                                    new Date(el.dateOfSubscription),
                                    "dd MMM yyyy"
                                  )
                                : "..."}{" "}
                            </td>
                            <td>
                              {el.activationDate
                                ? format(
                                    new Date(el.activationDate),
                                    "dd MMM yyyy"
                                  )
                                : "..."}{" "}
                            </td>
                            {/* <td>
                      {el?.progress && el?.progress?.targetDashboard
                        ? el?.progress?.targetDashboard?.progress
                        : 0}{" "}
                      %
                    </td>
                    <td>
                      <div
                        onClick={() => verifyCustomer(el)}
                        className="p-cursor"
                      >
                        <Badge bg={el?.isVerified ? "success" : "light"}>
                          {el?.isVerified ? "Verified" : "Not Verified"}
                        </Badge>
                      </div>
                    </td>
                    <td>{el?.verifiedBy}</td> */}
                            <td>
                              {Number(el?.initialActivateCustomer) ? (
                                Boolean(Number(el?.activateCustomer)) ? (
                                  <div
                                    className={
                                      filterParams?.TransType === "delist"
                                        ? " text-black"
                                        : " text-success"
                                    }
                                  >
                                    Active
                                  </div>
                                ) : (
                                  <div
                                    className={
                                      filterParams?.TransType === "delist"
                                        ? " text-black"
                                        : "  text-danger"
                                    }
                                  >
                                    Expired
                                  </div>
                                )
                              ) : (
                                <div className=" text-warning">
                                  No Active Subscription
                                </div>
                              )}
                            </td>
                            <td>
                              {el.delistDate
                                ? format(new Date(el.delistDate), "dd MMM yyy")
                                : "..."}
                            </td>
                            <td>
                              {el.enlistDate
                                ? format(new Date(el.enlistDate), "dd MMM yyy")
                                : "..."}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>

                  {!isFetching && isSuccess && isEmpty(data?.customers) ? (
                    <NoTableItem queryParams={queryParams} />
                  ) : null}
                </div>

                <div className="d-flex justify-content-between px-4 align-items-center pagination pb-4 ">
                  <div className="pagination_left d-flex gap-3 align-items-center">
                    <p className="m-0 p-0">Show</p>
                    <select
                      value={queryParams.limit}
                      name="limit"
                      className="form-select "
                      onChange={(e) => handleSearchQueryChange(e)}
                    >
                      <option value="10">10 rows</option>
                      <option value="20">20 rows</option>
                      <option value="30">30 rows</option>
                      <option value="40">40 rows</option>
                    </select>
                  </div>

                  <ReactPaginate
                    {...paginationOptions}
                    pageCount={Math.ceil(data.count / queryParams.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={0}
                    onPageChange={({ selected }) => {
                      document.body.scrollTop = document.documentElement.scrollTop = 0;
                      setQueryParams({
                        ...queryParams,
                        page: selected + 1,
                      });
                    }}
                    forcePage={queryParams.page - 1}
                  />
                </div>

                {showCreateNewCustomerModal && (
                  <NewCustomerModal
                    showCreateNewCustomerModal={showCreateNewCustomerModal}
                    setShowCreateNewCustomerModal={
                      setShowCreateNewCustomerModal
                    }
                    refetch={refetch}
                  />
                )}

                {showEditCustomerModal && selectedCustomer ? (
                  <EditCustomerModal
                    showEditCustomerModal={showEditCustomerModal}
                    setShowEditCustomerModal={setShowEditCustomerModal}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                    refetch={refetch}
                  />
                ) : null}

                {showSalesRepManager && selectedCustomer ? (
                  <SetSalesRepModal
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                    setShowSaleRepModal={setShowSalesRepManager}
                  />
                ) : null}

                {showProductModal && selectedCustomer ? (
                  <CustomerProducts
                    showProductModal={showProductModal}
                    setShowProductModal={setShowProductModal}
                    selectedCustomer={selectedCustomer}
                    itemRefetch={refetch}
                  />
                ) : null}

                <ModalLoader
                  title="Downloading Excel..."
                  show={isfetchingExcel}
                />

                <ModalLoader
                  show={
                    deleteCustomerMutation.isLoading ||
                    verifyCustomerMutation.isLoading
                  }
                />
              </div>
            </div>
          </div>
        </main>
      </section>

      {selectedCustomerOpeningBalance && (
        <CustomerOpeningBalance
          show={selectedCustomerOpeningBalance}
          setShow={setSelectedCustomerOpeningBalance}
          customer={selectedCustomerOpeningBalance}
        />
      )}

      {
        <CustomersPasswordModal
          onHide={() => setPasswordModal({ ...passwordModal, modal: false })}
          show={passwordModal.modal}
          modalName={passwordModal.name}
          userId={passwordModal.userId}
          Branch={passwordModal.Branch}
        />
      }

      {showNewRequisitionModal && (
        <NewCustomerRequisition
          modalTitle="Send for Approval"
          defaultFormValues={{
            title: newRequisition.title,
            description: newRequisition.description,
            type: newRequisition.type,
            cost: newRequisition.cost,
            vendor: newRequisition.vendor,
            loanDetails: JSON.stringify(newRequisition?.loanDetails),
          }}
          Cust_ID={newRequisition.Cust_ID}
          setShowNewRequisitionModal={setShowNewRequisitionModal}
          handleCreatedRequisition={() => {}}
          refetch={refetch}
        />
      )}
    </IsPrivileged>
  );
}
